import React, { useEffect, useState, useRef } from 'react';
import {
    Box,
    Button,
    Heading,
    HStack,
    useToast,
    Badge,
    Text,
    VStack,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Flex
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { fetchDSAdminTicket } from '../actions/DSadminAction';
import DataTableWithHeaderSettings from '../components/DataTableWithHeaderSettings';
import DataTableJson from '../components/DataTableJson';




const ResultControllingTktDetails = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const gID = queryParams.get('gID');
    const dID = queryParams.get('dID');
    const [status, setStatus] = useState("Disconnected from server."); // Connection status
    const [statusColor, setStatusColor] = useState("red"); // Status text color
    const [isConnected, setIsConnected] = useState(false); // WebSocket connection state
    const [drawTicketDetials, setDrawTicketDetails] = useState({
        Test: 0,
        game_settings: [],
        ticket: []
    });

    // const { loading, ds_admin_ticket, error } = useSelector((state) => state.ds_admin_ticket);
    const { loading, ds_admin_ticket, error } = useSelector((state) => state.ds_admin_ticketList);


    const socketRef = useRef(null); // Stores WebSocket instance persistently
    let pingInterval;
    useEffect(() => {

        if (!socketRef.current) {
            console.log("use effect is connected")
            socketRef.current = new WebSocket('ws://localhost:5003/ws/ticketBooked');
            socketRef.current.onopen = () => {
                setIsConnected("true");
                on_open();
            }
            socketRef.current.onmessage = (event) => {
                //   console.log("Received:", event.data);
                //  console.log('onmessage');
                onmessage(event);
            }//(event) => console.log('Message:', event.data);
            socketRef.current.onclose = (event) => {
                console.log('WebSocket Disconnected');
                clearInterval(pingInterval);

                if (event.code !== 1000) { // Don't reconnect if it was a manual close
                    reconnectWebSocket();
                }
            }
        }



        return () => {
            if (socketRef.current) {
                console.log('WebSocket status', isConnected);
                if (isConnected) {
                    socketRef.current.close(); // Close WebSocket on unmount
                    socketRef.current = null;
                }
                // socketRef.current.close(); // Close WebSocket on unmount

            }
        };


    }, []);


    useEffect(() => {
        console.log("use effect ", dID)
        dispatch(fetchDSAdminTicket(gID, dID));
    }, [gID, dID]);

    const disconnectWebSocket = () => {
        if (socketRef.current) {
            //setIsConnected("false");
            socketRef.current.close();
            socketRef.current = null;
            console.log('Disconnected from server.');
            setStatus("Disconnected from server.");
            setStatusColor("red");
            setDrawTicketDetails([]);


        }
    };

    const reconnectWebSocket = () => {
        console.log("Reconnecting WebSocket in 5 seconds...");
        setTimeout(() => {
            startWebSocket();
        }, 5000); // Reconnect after 5 seconds
    };


    const startWebSocket = () => {

        if (!socketRef.current && false) {
            socketRef.current = new WebSocket('ws://localhost:5003/ws/ticketBooked');
            socketRef.current.onopen = on_open;
            socketRef.current.onmessage = (event) => {
                console.log("Received:", event.data);
                onmessage(event);
            }; //(event) => console.log('Message:', event.data);
            socketRef.current.onclose = () => {
                console.log('WebSocket Disconnected');
                stopWebSocket();
            }
        } else {
            console.log("WebSocket already started.");
        }


    };

    const on_open = () => {
        console.log('WebSocket Connected');
        // setStatus("Connected to server.");
        // setStatusColor("green");
        setIsConnected("true");
        changeStatus(true)
    }

    const stopWebSocket = () => {
        if (socketRef.current) {
            socketRef.current.close();
            console.log('Disconnected from server.');
            // setStatus("Disconnected from server.");
            // setStatusColor("red");
            // setIsConnected(false);
            changeStatus(false)

        } else {
            console.log('socket from server.');
            changeStatus(false);
        }
    };

    const changeStatus = (status) => {
        if (status) {
            setStatus("Connected to server.");
            setStatusColor("green");
            setIsConnected(true);
        } else {
            setStatus("Disconnected from server.");
            setStatusColor("red");
            setIsConnected(false);
        }

    }

    const getTicketDetails = () => {

    };

    const onmessage = (event) => {
        try {
            console.log('WebSocket on message .... to ds', isConnected);
            console.log('WebSocket on message ', isConnected);
            const data = JSON.parse(event.data);
            console.log("Parsed data:", data);
            setDrawTicketDetails(data); // Update state with parsed data
            if (isConnected) {
                console.log('WebSocket on message ', isConnected);
                const data = JSON.parse(event.data);
                console.log("Parsed data:", data);
                setDrawTicketDetails(data); // Update state with parsed data
            } else {
                console.log("isConnected data:", isConnected);
            }

            console.log("data ", drawTicketDetials)

        } catch (error) {
            console.error("Failed to parse JSON:", error);
        }

    };

    const createTableFromJson = (data, linkID) => {
        console.log("ct ", data)
        if (!data || data.length === 0) return null;

        const columns = Object.keys(data[0]);
        return (
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th
                                key={col}
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    textAlign: "left",
                                }}
                            >
                                {col}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index}
                            style={{ border: "1px solid #ccc", padding: "8px", cursor: 'pointer' }}
                        >
                            {columns.map((col) => (
                                <td
                                    key={col}
                                    style={{ border: "1px solid #ccc", padding: "8px" }}

                                >
                                    {row[col]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };


    if (error) return <p>{error}</p>;
    return (
        <div>
            <h3>Ticket History for IDs: {gID}, {dID}</h3>
            {/* You can now use id1 and id2 in your component */}
            <Button colorScheme="green" onClick={startWebSocket} disabled={isConnected}>Start</Button>
            <Button colorScheme="red" onClick={stopWebSocket} disabled={!isConnected}>Stop</Button>
            <Button colorScheme="yellow" onClick={getTicketDetails} >Load Draw Payload</Button>
            <p style={{ color: statusColor }}>{status}</p>
            <br></br>


            <Box>
                Test:   {drawTicketDetials.Test}

                <div id='scoreboard'>
                    <div className="section">
                        <h3>Games</h3>

                        {
                            drawTicketDetials != undefined ? (

                                drawTicketDetials.game_settings ? (
                                    createTableFromJson(drawTicketDetials.game_settings, true)
                                ) : (
                                    <p>No GameSettings available.</p>
                                )
                            ) : (
                                <p>No game_settings </p>
                            )}


                    </div>
                    <div>
                        DS admin

                         {ds_admin_ticket ? (
                            Array.isArray(ds_admin_ticket.ticket) && ds_admin_ticket.ticket.length > 0 ? (
                               // createTableFromJson(ds_admin_ticket.ticketDetails, true)
                                 //<DataTableWithHeaderSettings data={ds_admin_ticket.ticket} />
                                 <DataTableJson json={ds_admin_ticket} />
                            ) : (
                                <p>Blank Ticket</p>
                            )
                        ) : (
                            <p>No Ticket</p>
                        )} 
                        
                    </div>
                </div>

            </Box>
        </div>
    );

}
export default ResultControllingTktDetails;